import enUS from './en.json'
import ja from './ja.json'

export default {
  'en-US': enUS,
  'ja': ja
}
